import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Text, FontIcon, Image } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { OPTIONS, optionTitles, getOptionImages } from './consts';
import { getWebsiteItemStyles as getStyles, websiteItemStyles } from './styles';

export const WebsiteItem = (props) => {
  const {
    selected,
    onClick,
    type,
    isShowIcon,
    isRebranding,
    selectedIcon,
    unselectedIcon,
  } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  const optionImages = useMemo(() => getOptionImages(isShowIcon, isRebranding), [isShowIcon, isRebranding]);

  const { ariaLabel, iconName, iconClass } = useMemo(() => {
    let label = null;
    let name = null;
    let classname = null;

    if (selected) {
      label = i18n.getString(_TL_('Selected option'));
      name = selectedIcon || 'CompletedSolid';
      classname = classes.icon;
    } else if (unselectedIcon) {
      label = i18n.getString(_TL_('Unselected option'));
      name = unselectedIcon;
      classname = classes.iconNotSelected;
    }

    return { ariaLabel: label, iconName: name, iconClass: classname };
  }, [selected, unselectedIcon, i18n, selectedIcon, classes]);


  return (
    <button
      className={classNames(
          `${type}-option`,
          classes.item,
          selected ? classes.optionSelected : classes.optionNotSelected,
          selected && 'selected',
          isShowIcon ? classes.itemContainerWithIcon : classes.itemContainerWithoutIcon,
          isRebranding && classes.itemContainerRebranding
        )}
      onClick={onClick}
    >
      <Image
        src={optionImages[type].imageSrc}
        alt={i18n.getString(optionImages[type].alt)}
        styles={websiteItemStyles.image}
        className={!isShowIcon && classes.imgContainer}
        aria-hidden="true"
      />
      <Text
        variant="medium"
        block
        styles={websiteItemStyles.title}
      >
        {i18n.getString(optionTitles[type])}
      </Text>
      {iconName && <FontIcon aria-label={ariaLabel} iconName={iconName} className={iconClass} />}
    </button>
  );
};

WebsiteItem.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(_.values(OPTIONS)).isRequired,
  isShowIcon: PropTypes.bool.isRequired,
  isRebranding: PropTypes.bool,
  selectedIcon: PropTypes.string,
  unselectedIcon: PropTypes.string,
};

WebsiteItem.defaultProps = {
  isRebranding: false,
  selectedIcon: null,
  unselectedIcon: null,
};
